import { put, takeEvery, all } from 'redux-saga/effects';
import * as constants from '../constants/calendar';
import { Log } from 'ng2-logger';
import { CalendarService } from '../../api/calendar-service';
import * as coreActions from '../actions/core';
import { Notification } from '../../components/notification/main';
import Translator from '../../core/i18n';
import { IGetCalendarDatas } from '../../models/action/calendar';
import * as calendarPageAction from '../actions/calendar';

const T = Translator.create();
const _logger = Log.create('calendar_sagas');
const _calendarService = new CalendarService();

function* getCalendarDatas(params: IGetCalendarDatas) {
    let isError = false;
    let errorList: any;
    let pageData: any;
    try {
        const myYield = _calendarService.RequestGetCalendarDatasAsync(params).then((responseData: Response) => {
            return responseData;
        }).then((responseData: Response) => {
            if (responseData.status !== 200) {
                isError = true;
            }
            return responseData.json();
        }).then((response) => {
            if (isError) {
                errorList = response;
            } else {
                pageData = response;
            }
        });
        yield myYield;
        if (isError) {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        } else {
            yield put(calendarPageAction.SetCalendarData(pageData));
        }

        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', error, 'topRight');
    }
}

export function* watchGetCalendarDatas() {
    yield takeEvery(constants.actions.GET_CALENDAR_DATAS, getCalendarDatas);
    return null;
}

export function* CalendarSagas() {
    yield all([
        watchGetCalendarDatas()
    ]);
}
